import type { BulkReassignmentFields } from "@/components/Table/BulkAssignment";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useBulkCaseReassignment = (): UseMutationResult<
    void,
    Error,
    {
        caseIds: string[];
        assignments: BulkReassignmentFields;
    }
> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ caseIds, assignments }) => {
            const response = await fetch(apiUrl("/dashboard/bulk-assignment"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    caseIds: caseIds,
                    assignments: assignments,
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["case-table-data"],
            });
            await queryClient.invalidateQueries({
                queryKey: ["dashboard-cases-table-data"],
            });
        },
    });
};
